<template>
    <modal ref="modal">
        <div id="sub-wrapper">
            <form @submit="submit">
              <div class="title">{{ $t('modals.message_contributors.title') }}</div>
              <div>
                  <label>{{ $t('labels.contributors') }} *</label>
                  <toggles :class="errors['to'] ? ' error' : ''" v-model='to' :list='list()'/>
                  <div class="error" v-if="errors['to']">{{ errors['to'] }}</div>
              </div>
              <div>
                  <label>{{ $t('labels.message') }} *</label>
                  <textarea ref="message" @keyup.enter.exact='submit' @keydown.enter.exact.prevent v-model="message" :class="errors['message'] ? 'error' : ''"/>
                  <div class="error" v-if="errors['message']">{{ errors['message'] }}</div>
              </div>
              <button>{{ $t('modals.message_contributors.button') }}</button>
            </form>
        </div>
    </modal>
</template>

<script>
import event from '@/services/event'

export default {
  props: {
    contributions: Array
  },
  data () {
    return {
      defaultErrKey: 'message',
      errors: {},
      message: '',
      to: []
    }
  },
  methods: {
    list () {
      var l = []
      this.contributions.forEach(contribution => {
        l.push({
          disabled: !contribution.messageable,
          id: contribution.id,
          initial: contribution.messageable,
          name: contribution.name + (!contribution.messageable ? ' (unavailable)' : ''),
          value: contribution.id
        })
      })
      return l
    },
    show () {
      this.errors = {}
      this.message = ''
      this.to = []
      this.$refs.modal.show()
      this.$nextTick(function () {
        this.$refs.message.focus()
      }.bind(this))
    },
    hide () {
      this.$refs.modal.hide()
    },
    submit (e) {
      // Init
      e.preventDefault()
      this.errors = {}

      // Check to
      if (this.to.length === 0) {
        this.errors = { 'to': this.$i18n.t('mandatory.contributors') }
        return
      }

      // Check message
      if (!this.message || this.message === '') {
        this.errors = { 'message': this.$i18n.t('mandatory.message') }
        return
      }

      // Send message
      event.sendMessage(this.message, this.to)
        .then(message => {
          // Hide
          this.hide()

          // Toast
          this.$parent.$parent.$parent.$refs.toaster.success(message)
        })
        .catch(err => {
          if (err.messages) this.errors = err.messages
          else {
            this.errors = {}
            this.errors[this.defaultErrKey] = this.$i18n.t('errors.default')
          }
        })
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  width: 25em;
}

#sub-wrapper textarea {
  height: 4.5em;
}

</style>
